<script setup>
import { computed } from "vue";
import { useStore } from "vuex";
import { IMAGE_SHAPES } from "@/store/modules/output";

const emit = defineEmits(["picked"]);
const store = useStore();

const imageShape = computed(() => store.state.output.imageShape);
const pick = (shape) => {
  store.dispatch("output/selectImageShape", shape);
  emit("picked", shape);
};
</script>

<template>
  <div class="flex flex-wrap gap-2" role="group" aria-label="Image shape">
    <button
      v-for="shape in IMAGE_SHAPES"
      :key="shape.id"
      type="button"
      :aria-pressed="imageShape === shape.id"
      class="flex items-center rounded-full px-3 py-1 text-sm font-medium focus:outline-none focus-visible:ring-2 focus-visible:ring-accentPrimary"
      :class="
        imageShape === shape.id
          ? 'bg-accentSecondary text-primary'
          : 'bg-gray-10 text-secondary hover:bg-gray-100'
      "
      @click="pick(shape.id)"
    >
      <span
        v-if="shape.id !== 'auto'"
        aria-hidden="true"
        class="mr-2 inline-block border-2 border-current rounded-sm"
        :class="{
          'h-3 w-3': shape.id === 'square',
          'h-4 w-3': shape.id === 'portrait',
          'h-3 w-4': shape.id === 'landscape',
        }"
      />
      {{ shape.label }}
    </button>
  </div>
</template>
